var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.kindTheme===0)?_c('top-header-theme0'):(_vm.kindTheme===1)?_c('top-header-theme1'):(_vm.kindTheme === 2)?_c('top-header-theme2'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }